import {
  LetterbookType,
  LetterlistTableColumnSettingType,
} from "features/Letterbooks/types";
import LetterbookCell from "../LetterbookCell";

export default function ReleaseYearColumn({
  letterbook,
}: {
  letterbook: LetterbookType;
}) {
  const { book } = letterbook;
  return (
    <LetterbookCell className="font-bold text-lg">
      <>{book.releaseYear}</>
    </LetterbookCell>
  );
}

export const settings = {
  key: "ReleaseYear",
  title: "Release Year",
} as LetterlistTableColumnSettingType;
